<template>
  <div id="videos" v-if="hasVideos">
    <div id="video_list">
      <div v-for="(videoURL, index) in videosURL" :key="index" >
      <iframe width="100%" height="200" :src="videoURL" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      </div>
  </div>
</template>


<script>

import {getServiceVideos} from "@/modules/CustomerPortal/api/services/view";
export default {
  name: "ServiceViewRightMenuVideos",
  components: {getServiceVideos},
  props: [
    // visit: Object,
    "service_id"
  ],
  data() {
    return {
      videos: [],
      videosURL: [],
      hasVideos: 0,
    }
  },
  methods:{

  },
  computed: {

  },
  mounted(){
    getServiceVideos(this.service_id).then((response) => {
      if(response.status == 200){
        if(response.data.type == 'success'){
            this.videos = response.data.videos
            this.hasVideos = 1;
            for (let i = 0; i < this.videos.length; i++){
              this.videosURL.push("https://www.youtube.com/embed/" + this.videos[i]);
            }
        }
      }
    })
  }
}
</script>

<style scoped>
#videos iframe {
  border-radius: 5px;
}
</style>
